import { alpha } from '@mui/material/styles';

import type { OverWritable } from '../../@types/settings';

export const skeleton: OverWritable = {
  MuiSkeleton: {
    defaultProps: {
      animation: 'wave',
    },

    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: alpha(theme.palette.grey[500], 0.24),
      }),
    },
  },
};
